<script setup lang="ts">
import type { TitleType } from './bootstrap-panel';

const props = defineProps<{
    title?: string | boolean;
    //h1 is centered, div is not, default is h1
    titleType?: TitleType;
    footer?: boolean;
}>();
</script>
<template>
    <div class="panel panel-default">
        <div v-if="props.title" class="panel-heading">
            <Component :is="props.titleType || 'h1'" class="panel-title">
                <slot name="title">
                    <template v-if="props.title !== true">
                        {{ props.title }}
                    </template>
                </slot>
            </Component>
        </div>
        <div class="panel-body">
            <slot />
        </div>
        <div v-if="props.footer" class="panel-footer">
            <slot name="footer" />
        </div>
    </div>
</template>
